'use strict';

$ = jQuery;

/*
* Evento de clique em marcas
*/
$('.jc-catalog-brand a').on('click', function () {
  dataLayer.push({
    'event': 'ga_event',
    'eventCategory': 'Catálogo 0km',
    'eventAction': 'Clique - Marca',
    'eventLabel': $(this).find('p').text()
  });

  gtag('event', 'Catálogo 0km', {
    'eventAction': 'Clique - Marca',
    'eventLabel': $(this).find('p').text()
  });
});